import { Tabs } from '@mage-ui/components';
import { useContext } from 'react';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { DetailInnerSection } from '@/components/ui/layouts/sections/DetailInnerSection';
import { Instances } from '../Instances';

export const TableGroupBlock = ({ data }) => {
	const { st } = useContext(StaticTextContext);

	const filteredTabs = (data?.relations?.TabsList || []).reduce((acc, tab) => {
		const title = tab?.fields?.title;
		const hasTables =
			Array.isArray(tab?.relations?.TablesList) &&
			tab.relations.TablesList.length > 0;

		if (hasTables && title && !acc.some((t) => t.fields?.title === title)) {
			acc.push(tab);
		}
		return acc;
	}, []);

	if (filteredTabs.length === 0) {
		return null;
	}

	return (
		<DetailInnerSection
			anchor={{ text: st('body.goto') }}
			heading={{
				title: data?.fields?.title,
			}}
			isRelation={data?.meta?.has_relations}
		>
			<Tabs
				defaultValue={
					filteredTabs[0]?.meta?.id
						? `tab-${filteredTabs[0]?.meta?.id}`
						: undefined
				}
			>
				<Tabs.List>
					{filteredTabs.map((tab, idx) => (
						<Tabs.Tab key={tab?.meta?.id || idx} value={`tab-${tab?.meta?.id}`}>
							{tab.fields?.title}
						</Tabs.Tab>
					))}
				</Tabs.List>
				{filteredTabs.map((tab, idx) => (
					<Tabs.Panel key={tab?.meta?.id || idx} value={`tab-${tab?.meta?.id}`}>
						<Instances instances={[tab.relations?.TablesList[0]]} />
					</Tabs.Panel>
				))}
			</Tabs>
		</DetailInnerSection>
	);
};
